import { render, staticRenderFns } from "./tw_pinglun.vue?vue&type=template&id=ab166d38&scoped=true&"
import script from "./tw_pinglun.vue?vue&type=script&lang=js&"
export * from "./tw_pinglun.vue?vue&type=script&lang=js&"
import style0 from "./tw_pinglun.vue?vue&type=style&index=0&id=ab166d38&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab166d38",
  null
  
)

export default component.exports